var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _polygon, _path0, _polygon2, _circle2, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevel2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 83.87 91.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c1dcf7;}.cls-1,.cls-2,.cls-3,.cls-4{stroke-width:0px;}.cls-2,.cls-5,.cls-3{fill:#6d95d3;}.cls-5,.cls-6{stroke:#4774b5;stroke-miterlimit:10;stroke-width:1.02px;}.cls-6{fill:none;}.cls-3{opacity:.3;}.cls-4{fill:#89b0e8;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2.42,23.21C4.83,18.2,36.98.54,41.74.51c4.75-.02,36.97,18.36,39.32,22.7s3.72,39.71,0,45.4-33.57,22.98-39.32,22.7c-5.74-.28-36.64-18.06-39.32-22.7C-.26,63.97.01,28.22,2.42,23.21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.01,37.09c-.37-6.16-.99-11.34-1.74-13.38-1.59,1.12-1.71,4.25-1.27,7.41.43,3.09,1.23,5.26,3.01,5.97Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.66,12.61c19.17,10.72,21.39,10.6,21.39,10.6C78.71,18.87,46.49.49,41.74.51c0,0-1.25,1.38,17.92,12.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M8.88,26.92c2.01-4.19,28.91-18.97,32.89-18.99s30.93,15.36,32.89,18.99,3.12,33.22,0,37.98c-3.12,4.76-28.09,19.22-32.89,18.99-4.8-.23-30.65-15.11-32.89-18.99-2.24-3.88-2.01-33.79,0-37.98Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2.42,23.21C4.83,18.2,36.98.54,41.74.51c4.75-.02,36.97,18.36,39.32,22.7s3.72,39.71,0,45.4-33.57,22.98-39.32,22.7c-5.74-.28-36.64-18.06-39.32-22.7C-.26,63.97.01,28.22,2.42,23.21Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.15,27.82c1.92-3.99,27.55-18.08,31.34-18.1s29.47,14.63,31.34,18.1c1.87,3.46,2.97,31.65,0,36.19s-26.76,18.32-31.34,18.1-29.21-14.39-31.34-18.1-1.92-32.2,0-36.19Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.2,25.71c.02-.12.09-.23.17-.27.94-.54,2.45-1.06,4.1-1.51.99-1.38,2.03-2.56,2.88-3.26.07-.06.19-.09.32-.09.13,0,.25.04.32.1.81.7,1.8,1.86,2.75,3.22,1.68.48,3.23,1.04,4.18,1.61.08.05.14.15.16.28.02.12,0,.25-.04.33-.55,1-1.31,2.23-2.32,3.54.04,1.65,0,3.2-.1,4.49,0,.11-.08.22-.2.29-.11.07-.25.09-.36.06-1.33-.34-2.83-.73-4.45-1.26-1.63.51-3.13.89-4.46,1.22-.04.01-.09.01-.13.01-.08,0-.16-.03-.23-.08-.11-.07-.19-.18-.19-.29-.11-1.31-.14-2.9-.09-4.57-.98-1.29-1.72-2.5-2.26-3.48-.05-.09-.06-.21-.04-.34Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M72.83,27.82c-1.87-3.46-27.55-18.11-31.34-18.1-3.79.02-29.42,14.1-31.34,18.1-1.92,3.99-2.13,32.49,0,36.19,2.13,3.7,26.76,17.87,31.34,18.1,4.58.22,28.37-13.56,31.34-18.1s1.87-32.73,0-36.19ZM70.55,62.68c-2.75,4.2-24.81,16.98-29.05,16.77s-27.07-13.34-29.05-16.77c-1.98-3.43-1.78-29.85,0-33.55,1.78-3.7,25.54-16.76,29.05-16.77s27.32,13.57,29.05,16.77c1.73,3.21,2.75,29.34,0,33.55Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M10.15,27.82c1.92-3.99,27.55-18.08,31.34-18.1s29.47,14.63,31.34,18.1c1.87,3.46,2.97,31.65,0,36.19s-26.76,18.32-31.34,18.1-29.21-14.39-31.34-18.1-1.92-32.2,0-36.19Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 27.32,
    cy: 51.64,
    r: 13.49
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "17.1 69.58 17.1 69.58 17.1 69.58 17.1 69.58"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.36,68.14c-1.4-1.64-14.12-1.78-17.67-.42,5.56,3.68,13.5,8.13,18.57,10.35-.31-4.8-.62-9.59-.9-9.93Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "37.45 80.82 37.45 80.82 37.45 80.82 37.45 80.82"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 55.97,
    cy: 51.64,
    r: 13.49
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.82,67.92c-.3.3-.61,5.17-.94,10.28,5.22-2.18,13.33-6.77,18.88-10.61-2.99-1.46-16.27-1.35-17.94.33Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel2);
export default __webpack_public_path__ + "static/media/level-2.042942875b4d8afdd73c08377541e336.svg";
export { ForwardRef as ReactComponent };